const getCurrentYear = require('../lib/getCurrentYear');

const SEO_PRODUCT = {
  act: {
    gtin: '198715504125',
    name: 'Achievable ACT',
    description:
      "Get ACT test prep built for today's learners - mobile, guided, and personalized. Reach your target ACT score with our powerful online self-study course and practice questions for math, English, science, reading, and writing.",
    sku: 'act',
    offerUrl: 'https://app.achievable.me/study/act/purchase',
    price: '129.00',
    priceF: '$129',
    firstPage: 'https://app.achievable.me/study/act/learn/act-math-intro-overview',
    shortExamName: 'ACT',
    fullExamName: 'ACT',
    cta: 'Ace your ACT',
    hasGuarantee: false,
    canonical: '/exams/act/overview/',
    keywords:
      'Act, act test, act prep, act exam, act test prep, act prep online, act prep courses, act math, act english, act reading, act writing, act science, act practice test, act math practice, act english practice, act reading practice, act writing practice, act science practice, act math test, act english test, act reading test, act writing test, act science test, act tips, act math tips, act english tips, act reading tips, act writing tips, act science tips, act math formulas, act writing score',
    title: 'Modern online ACT test prep with endless practice questions',
    imageUrl: 'https://assets.achievable.me/products/act/gmc--act--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/act/marketing/act--mobile--textbook-nonlinear-functions.png',
      'https://assets.achievable.me/products/act/marketing/act--mobile--textbook-absolute-value.png',
      'https://assets.achievable.me/products/act/marketing/act--mobile--evaluate-expression.png',
      'https://assets.achievable.me/products/act/marketing/act--mobile--dashboard.png',
      'https://assets.achievable.me/products/act/marketing/act--desktop--textbook-nonlinear-functions.png',
      'https://assets.achievable.me/products/act/marketing/act--desktop--textbook-absolute-value.png',
      'https://assets.achievable.me/products/act/marketing/act--desktop--evaluate-expression.png',
      'https://assets.achievable.me/products/act/marketing/act--desktop--dashboard.png',
    ],
  },
  'amc-8': {
    gtin: '',
    name: 'Achievable AMC 8',
    description:
      "Prepare with the best online AMC 8 self-study prep course. Built for today's students: mobile, guided, and personally optimized.",
    sku: 'amc-8',
    offerUrl: 'https://app.achievable.me/study/amc-8/purchase',
    price: '19.00',
    priceF: '$19',
    firstPage: 'https://app.achievable.me/study/amc-8/learn/introduction-editing',
    shortExamName: 'AMC 8',
    fullExamName: 'AMC 8',
    cta: 'Ace your AMC',
    hasGuarantee: false,
    canonical: '/exams/amc-8-10-12/overview/',
    keywords:
      'amc, amc 8, amc 10, amc 12, amc exam prep, amc exam difficulty, amc practice exam',
    title: 'Modern AMC exam prep; reach your target score',
    imageUrl: 'https://assets.achievable.me/products/amc-12/gmc--amc-12--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--textbook-strategy.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--quiz-sincos.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--dashboard.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--textbook-strategy.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--textbook-circles.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--dashboard.png',
    ],
  },
  'amc-12': {
    gtin: '198715144055',
    name: 'Achievable AMC 8/10/12',
    description:
      "Prepare with the best online AMC 8/10/12 self-study prep course. Built for today's students: mobile, guided, and personally optimized.",
    sku: 'amc-12',
    offerUrl: 'https://app.achievable.me/study/amc-12/purchase',
    price: '99.00',
    priceF: '$99',
    firstPage: 'https://app.achievable.me/study/amc-12/learn/what-is-the-amc',
    shortExamName: 'AMC 8/10/12',
    fullExamName: 'AMC 8/10/12',
    cta: 'Ace your AMC',
    hasGuarantee: false,
    canonical: '/exams/amc-8-10-12/overview/',
    keywords:
      'amc, amc 8, amc 10, amc 12, amc exam prep, amc exam difficulty, amc practice exam',
    title: 'Modern AMC exam prep; reach your target score',
    imageUrl: 'https://assets.achievable.me/products/amc-12/gmc--amc-12--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--textbook-strategy.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--quiz-sincos.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--mobile--dashboard.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--textbook-strategy.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--textbook-circles.png',
      'https://assets.achievable.me/products/amc-12/marketing/amc--desktop--dashboard.png',
    ],
  },
  clt: {
    gtin: '198715048018',
    name: 'Achievable CLT',
    description:
      "Prepare with the best online CLT self-study prep course. Built for today's students: mobile, guided, and personally optimized.",
    sku: 'clt',
    offerUrl: 'https://app.achievable.me/study/clt/purchase',
    price: '199.00',
    priceF: '$199',
    firstPage: 'https://app.achievable.me/study/clt/learn/introduction',
    shortExamName: 'CLT',
    fullExamName: 'CLT',
    cta: 'Ace your CLT',
    hasGuarantee: false,
    canonical: '/exams/clt/overview/',
    keywords:
      'clt, clt test prep, clt exam prep, clt exam difficulty, classic learning test',
    title: 'Modern CLT exam prep; reach your target score',
    imageUrl: 'https://assets.achievable.me/products/clt/gmc--clt--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/clt/marketing/act--mobile--textbook-absolute-value.png',
      'https://assets.achievable.me/products/clt/marketing/act--mobile--evaluate-expression.png',
      'https://assets.achievable.me/products/clt/marketing/act--desktop--evaluate-expression.png',
    ],
  },
  'finra-sie': {
    gtin: '195893399505',
    name: 'Achievable SIE',
    description:
      "Pass the FINRA SIE on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 2,000+ review quizzes, and 35+ full-length practice exams.",
    sku: 'finra-sie',
    offerUrl: 'https://app.achievable.me/study/finra-sie/purchase',
    firstPage:
      'https://app.achievable.me/study/finra-sie/learn/common-stock-basic-characteristics',
    price: '99.00',
    priceF: '$99',
    shortExamName: 'SIE',
    fullExamName: 'FINRA SIE',
    cta: 'Pass your SIE',
    hasGuarantee: true,
    canonical: '/exams/finra-sie/overview/',
    keywords:
      'Sie, sie exam, sie exam prep, finra sie, sie exam difficulty, sie exam pass rate, finra sie practice exam',
    title: `Best SIE exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-sie/gmc--finra-sie--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-6': {
    gtin: '198715337655',
    name: 'Achievable Series 6',
    description:
      "Pass the FINRA Series 6 on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 800+ chapter review quizzes, and 35+ full-length practice exams.",
    sku: 'finra-series-6',
    offerUrl: 'https://app.achievable.me/study/finra-series-6/purchase',
    price: '129.00',
    priceF: '$129',
    firstPage: 'https://app.achievable.me/study/finra-series-6/learn/introduction',
    shortExamName: 'Series 6',
    fullExamName: 'FINRA Series 6',
    cta: 'Pass your Series 6',
    hasGuarantee: true,
    canonical: '/exams/finra-series-6/overview/',
    keywords:
      'Series 6, series 6 license, series 6 exam, finra series 6, series 6 pass rate, series 6 exam prep, series 6 study guide, series 6 practice exam',
    title: `Best Series 6 exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-series-6/gmc--finra-series-6--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-7': {
    gtin: '198715904802',
    name: 'Achievable Series 7',
    description:
      "Pass the FINRA Series 7 on your first try with Achievable's interactive, online exam preparation course. Includes everything you need: easy-to-understand online textbook, 2,000+ review quizzes, and 35+ full-length practice exams.",
    sku: 'finra-series-7',
    offerUrl: 'https://app.achievable.me/study/finra-series-7/purchase',
    price: '199.00',
    priceF: '$199',
    firstPage: 'https://app.achievable.me/study/finra-series-7/learn/common-stock-review',
    shortExamName: 'Series 7',
    fullExamName: 'FINRA Series 7',
    cta: 'Pass your Series 7',
    hasGuarantee: true,
    canonical: '/exams/finra-series-7/overview/',
    keywords:
      'Series 7, series 7 license, series 7 exam, finra series 7, series 7 pass rate, series 7 exam prep, series 7 study guide, series 7 practice exam',
    title: `Best Series 7 exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-s7/gmc--finra-series-7--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-9': {
    gtin: '198715057966',
    name: 'Achievable Series 9',
    description:
      "Pass the FINRA Series 9 on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 2,000+ review quizzes, and 18+ full-length practice exams.",
    sku: 'finra-series-9',
    offerUrl: 'https://app.achievable.me/study/finra-series-9/purchase',
    price: '249.00',
    priceF: '$249',
    firstPage:
      'https://app.achievable.me/study/finra-series-9/learn/introduction-exam-specifications',
    shortExamName: 'Series 9',
    fullExamName: 'FINRA Series 9',
    cta: 'Pass your Series 9',
    hasGuarantee: true,
    canonical: '/exams/finra-series-9/overview/',
    keywords:
      'series 9, series 9 license, series 9 exam, finra series 9, series 9 pass rate, series 9 exam prep, series 9 study materials, series 9 practice exam',
    title: `Modern Series 9 test prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-series-9/gmc--finra-series-9--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-63': {
    gtin: '198715418156',
    name: 'Achievable Series 63',
    description:
      "Pass the FINRA Series 63 on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 300+ chapter review quizzes, and 6+ full-length practice exams.",
    sku: 'finra-series-63',
    offerUrl: 'https://app.achievable.me/study/finra-series-63/purchase',
    price: '79.00',
    priceF: '$79',
    firstPage: 'https://app.achievable.me/study/finra-series-63/learn/introduction',
    shortExamName: 'Series 63',
    fullExamName: 'FINRA Series 63',
    cta: 'Pass your Series 63',
    hasGuarantee: true,
    canonical: '/exams/finra-series-63/overview/',
    keywords:
      'Series 63, series 63 license, series 63 exam, finra series 63, series 63 pass rate, series 63 exam prep, series 63 study guide, series 63 practice exam',
    title: `Best Series 63 exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-series-63/gmc--finra-series-63--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-65': {
    gtin: '198715536720',
    name: 'Achievable Series 65',
    description:
      "Pass the FINRA Series 65 on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 1,300+ chapter review quizzes, and 20+ full-length practice exams.",
    sku: 'finra-series-65',
    offerUrl: 'https://app.achievable.me/study/finra-series-65/purchase',
    price: '199.00',
    priceF: '$199',
    firstPage: 'https://app.achievable.me/study/finra-series-65/learn/introduction',
    shortExamName: 'Series 65',
    fullExamName: 'FINRA Series 65',
    cta: 'Pass your Series 65',
    hasGuarantee: true,
    canonical: '/exams/finra-series-65/overview/',
    keywords:
      'Series 65, series 65 license, series 65 exam, finra series 65, series 65 pass rate, series 65 exam prep, series 65 study guide, series 65 practice exam',
    title: `Best Series 65 exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-series-65/gmc--finra-series-65--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  'finra-series-66': {
    gtin: '198715738032',
    name: 'Achievable Series 66',
    description:
      "Pass the FINRA Series 66 on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, 1,200+ chapter review quizzes, and 26+ full-length practice exams.",
    sku: 'finra-series-66',
    offerUrl: 'https://app.achievable.me/study/finra-series-66/purchase',
    price: '199.00',
    priceF: '$199',
    firstPage:
      'https://app.achievable.me/study/finra-series-66/learn/investment-vehicle-characteristics-equity-common-stock',
    shortExamName: 'Series 66',
    fullExamName: 'FINRA Series 66',
    cta: 'Pass your Series 66',
    hasGuarantee: true,
    canonical: '/exams/finra-series-66/overview/',
    keywords:
      'Series 66, series 66 license, series 66 exam, finra series 66, series 66 pass rate, series 66 exam prep, series 66 study materials, series 66 practice exam',
    title: `Best Series 66 exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/finra-series-66/gmc--finra-series-66--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-yield.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--textbook-derp.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--quiz-bond.png',
      'https://assets.achievable.me/products/finra/marketing/sie--mobile--dashboard.png',
      'https://assets.achievable.me/products/finra/marketing/sie--desktop--quiz-bond.png',
    ],
  },
  gre: {
    gtin: '198715701012',
    name: 'Achievable GRE',
    description:
      "Hit your GRE target score on the first try with Achievable's interactive online exam preparation course. Includes everything you need: unlimited quantitative practice questions, an easy-to-understand online textbook, 24 verbal / reading comprehension practice exams, 250 vocabulary words, and unlimited instant essay grading.",
    sku: 'gre',
    offerUrl: 'https://app.achievable.me/study/gre-v2/purchase',
    price: '199.00',
    priceF: '$199',
    firstPage: 'https://app.achievable.me/study/gre-v2/learn/welcome',
    shortExamName: 'GRE',
    fullExamName: 'GRE',
    cta: 'Ace your GRE',
    hasGuarantee: false,
    canonical: '/exams/gre/overview/',
    keywords:
      'Gre, gre test, gre scores, gre test dates, gre practice test, gre scores, gre percentiles, gre exam, gre prep, gre exam prep, gre vocabulary, gre practice questions, gre score',
    title: 'Modern GRE exam prep with infinite practice questions',
    imageUrl: 'https://assets.achievable.me/products/gre-v2/gmc--gre-v2--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/gre-v2/marketing/gre--mobile--textbook-video.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--mobile--textbook-permutations.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--mobile--textbook-inequalities.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--mobile--quiz-polygon.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--mobile--dashboard.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--desktop--textbook-positive.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--desktop--textbook-permutations.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--desktop--textbook-graphing-inequalities-spoiler.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--desktop--polygon.png',
      'https://assets.achievable.me/products/gre-v2/marketing/gre--dashboard--desktop.png',
    ],
  },
  'insurance-life-health': {
    name: 'Achievable Life & Health insurance',
    description:
      "Pass the Life & Health insurance exam on your first try with Achievable's interactive online exam preparation course. Includes everything you need: easy-to-understand online textbook, chapter review quizzes, and full-length practice exams.",
    sku: 'insurance-life-health',
    offerUrl: 'https://app.achievable.me/study/insurance-life-health/purchase',
    price: '149.00',
    priceF: '$149',
    firstPage:
      'https://app.achievable.me/study/insurance-life-health/learn/general-insurance-concepts-managing-risks',
    shortExamName: 'Life & Health insurance',
    fullExamName: 'Life & Health insurance',
    cta: 'Pass your Life & Health',
    hasGuarantee: true,
    canonical: '/exams/insurance-life-health/overview/',
    keywords:
      'Life & Health insurance, life & health insurance license, life & health insurance exam, life & health insurance, life & health insurance pass rate, life & health insurance exam prep, life & health insurance study guide, life & health insurance practice exam',
    title: `Best Life & Health insurance exam prep; pass the first time (${getCurrentYear()})`,
    imageUrl:
      'https://assets.achievable.me/products/insurance-life-health/gmc--insurance-life-health--20250304.png',
  },
  'usmle-step-1': {
    gtin: '198715485639',
    name: 'Achievable USMLE Step 1',
    description:
      "Reach your USMLE Step 1 target score on the first try with Achievable's interactive online exam preparation course. Includes an easy-to-understand online textbook and 1,400+ review quizzes with explanations.",
    sku: 'usmle-step-1',
    offerUrl: 'https://app.achievable.me/study/usmle-step-1/purchase',
    price: '179.00',
    priceF: '$179',
    firstPage:
      'https://app.achievable.me/study/usmle-step-1/learn/overview-of-lymphoreticular-system',
    shortExamName: 'USMLE/1',
    fullExamName: 'USMLE Step 1',
    cta: 'Pass USMLE Step 1',
    hasGuarantee: true,
    canonical: '/exams/usmle-step-1/overview/',
    keywords:
      'Usmle, usmle step 1, usmle score, usmle score report, usmle step 1 scores, usmle step 1 percentile, usmle step 1 practice test',
    title: 'Modern USMLE Step 1 exam prep; reach your target score on the first try',
    imageUrl:
      'https://assets.achievable.me/products/usmle-step-1/gmc--usmle-step-1--20241216.png',
    additionalImageUrls: [
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--mobile--textbook-thoracic.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--mobile--textbook-senses.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--mobile--quiz-photoreceptors.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--mobile--quiz-photoreceptors-explanation.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--mobile--dashboard.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--desktop--textbook-senses.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--desktop--textbook-lymph.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--desktop--quiz-photoreceptors.png',
      'https://assets.achievable.me/products/usmle-step-1/marketing/usmle--desktop--dashboard.png',
    ],
  },
};

module.exports = SEO_PRODUCT;
